import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { environment } from '../../../environments/environment';
import { Group, PortalResponse, Product, Subscription, Tier, User } from '../models';
import { SeoService } from '../seo.service';

@Component({
    selector: 'app-payment',
    templateUrl: './payment.component.html',
    styleUrls: ['./payment.component.scss'],
})
export class PaymentComponent implements OnInit {
    braintreeToken: string;
    userToken: string;
    product: Product;
    subscription: Subscription;
    user: User;
    groups: Group[];
    userActiveTier: Tier;
    activeTier: Tier;
    frame = 'dashboard';
    activeGroup = 0;
    activeGroupTiers = 0;
    groupCounts: Record<number, number> = {};

    successUrl: string;
    cancelUrl: string;

    success = null;
    failure = null;
    lastErrorMessage = null;
    working = false;

    constructor(
        private http: HttpClient,
        private route: ActivatedRoute,
        private router: Router,
        private seo: SeoService,
        private location: Location
    ) {}

    ngOnInit() {
        this.route.queryParams.subscribe((p) => {
            this.userToken = p.token;
            this.successUrl = p.successUrl;
            this.cancelUrl = p.cancelUrl;

            if (environment.production) {
                this.location.replaceState('/subscribe');
            }

            if (!this.userToken) {
                this.router.navigateByUrl('/');
                return;
            }
            this.load();
        });
    }

    load() {
        this.working = true;

        this.http.get<PortalResponse>(`${environment.api}/v1/portal?token=${this.userToken}`).subscribe(
            (res) => {
                this.working = false;
                this.braintreeToken = res.token;
                this.product = res.product;
                this.subscription = res.subscription;
                this.user = res.user;
                this.groups = res.groups;

                let defaultGroupId = 0;

                res.product.tiers.forEach((t) => {
                    if (t.groupId) {
                        if (!defaultGroupId) {
                            defaultGroupId = t.groupId;
                        }

                        if (!this.groupCounts[t.groupId]) {
                            this.groupCounts[t.groupId] = 1;
                        } else {
                            this.groupCounts[t.groupId]++;
                        }
                    }
                });

                if (res.groups) {
                    res.groups.forEach((g) => {
                        if (g.default) {
                            if (this.groupCounts[g.id]) {
                                defaultGroupId = g.id;
                            }
                        }
                    });
                }

                document.head.insertAdjacentHTML('beforeend', `<style>${this.product.css}</style>`);

                this.seo.setTitle(`${this.product.name} - NitroPay Sponsor`);

                if (!this.product.primaryColor) {
                    this.product.primaryColor = '#283593';
                }

                this.product.tiers.sort((a, b) => (a.order < b.order ? -1 : 1));

                if (
                    this.subscription.subscribedUntil &&
                    new Date(this.subscription.subscribedUntil).getTime() > new Date().getTime()
                ) {
                    this.userActiveTier = this.product.tiers.find((p) => p.id === this.subscription.tier.id);
                }

                if (!this.activeTier) {
                    // this.activeTier = this.product.tiers[0];
                }
            },
            () => {
                console.log('Error fetching user data');
                this.router.navigateByUrl('/');
            }
        );
    }
}
